var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"yellow-square"}),_vm._l((_vm.block.innerBlocks),function(contents){return [_c('LazyBlock',{staticClass:"relative w-full md:w-[75vw] lg:w-[60vw]",attrs:{"block":contents}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }